<!--
 * @Description: Mongo文件管理页面
 * @Author: laoliu sunhuihong
 * @Date: 2022-07-31 11:43:52
 * @LastEditTime: 2023-01-09 18:43:27
-->
<template>
  <mongo-file-mng />
</template>

<script>
export default {
  mounted() {
    this.$emit("breadcrumb", {text1: '系统管理', text2: 'Mongo文件管理'});
  }
}
</script>


// WEBPACK FOOTER //
// src/components/sysmng/FileMng.vue